const Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export const makeId = (length: number) => {
    let result = '';

    for (let counter = 0; counter < length; counter++)
      result += Chars.charAt(Math.floor(Math.random() * Chars.length));

    return result;
}